import { Eye, EyeOff } from 'react-feather';

import { QueryActionsMenu } from './QueryActionsMenu';

export interface HiddenQueryItem {
  id: string;
  text: string;
}

interface HiddenVettingSectionProps {
  noun: string;
  items: HiddenQueryItem[];
  canShow: boolean;
  onShow: (id: string) => void;
}

/** The "Hidden from experts" section below the visible vetting list (ENG-5292). */
export function HiddenVettingSection({
  noun,
  items,
  canShow,
  onShow,
}: HiddenVettingSectionProps): JSX.Element | null {
  if (items.length === 0) return null;

  return (
    <div className="mt-24">
      <div className="mb-12 flex items-center gap-10">
        <EyeOff className="h-16 w-16 text-alert-warning" />
        <span className="text-14 font-bold text-on-surface-secondary">Hidden from experts</span>
        <span className="h-[1px] flex-1 bg-surface-border" />
      </div>
      <div className="flex flex-col gap-8">
        {items.map((item) => (
          <div key={item.id} className="flex items-center gap-10">
            <div className="min-w-0 flex-1 text-14 leading-normal text-on-surface-subtle line-through">
              {item.text}
            </div>
            {canShow && (
              <QueryActionsMenu
                id={`hidden-${noun}-${item.id}`}
                actions={[
                  {
                    key: 'show',
                    icon: Eye,
                    label: 'Show again',
                    tone: 'brand',
                    onClick: () => onShow(item.id),
                  },
                ]}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
